import { MeasurementToolActionTypes, AdvanceRoofSelectingActionTypes, BackgroundActionTypes, LOCATION_CHANGE, ProjectConfigurationActionTypes } from 'actionsConstants';
import { DrawingManagerActionTypes } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerActionsConstants';
import { createReducer } from '__common/utils/helpers';

export const measurementToolState: measurementToolState = {
  startingPoint: null,
  endingPoint: null,
  measurements: [],
  enabled: false,
  visible: false,
};

export default {
  measurementTool: createReducer(measurementToolState, {
    [MeasurementToolActionTypes.TURN_ON_MEASUREMENT_TOOL](state: measurementToolState) {
      return { ...state, enabled: true, visible: true };
    },
    [MeasurementToolActionTypes.TURN_OFF_MEASUREMENT_TOOL](state: measurementToolState, action: action & { payload: boolean }) {
      const hide = action.payload;
      return { ...state, startingPoint: null, endingPoint: null, enabled: false, visible: hide ? false : state.visible };
    },
    [BackgroundActionTypes.ACTIVE_PANELS_EDITOR](state: measurementToolState) {
        return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [DrawingManagerActionTypes.SET_SELECTED_ROOF_AND_MARKER](state: measurementToolState) {
        return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [BackgroundActionTypes.DEACTIVE_PANELS_EDITOR](state: measurementToolState) {
        return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [ProjectConfigurationActionTypes.LOAD_PROJECT_CONFIGURATION](state: measurementToolState) {
        return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [LOCATION_CHANGE](state: measurementToolState) {
        return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [MeasurementToolActionTypes.ADD_STARTING_POINT](state: measurementToolState, action) {
      const startingPoint = action.payload;
      return { ...state, startingPoint };
    },
    [MeasurementToolActionTypes.ADD_ENDING_POINT](state: measurementToolState, action: action & { payload: pixelPoint }) {
      const endingPoint = action.payload;
      return { ...state, endingPoint };
    },
    [MeasurementToolActionTypes.START_NEW_MEASUREMENT](state: measurementToolState) {
      const { startingPoint, endingPoint, measurements } = state;
      if (startingPoint && endingPoint) {
        return {
          ...state,
          startingPoint: null,
          endingPoint: null,
          measurements: [...measurements, { startingPoint, endingPoint }]
        };
      }
      return { ...state, startingPoint: null, endingPoint: null };
    },
    [MeasurementToolActionTypes.DELETE_MEASUREMENT](state: measurementToolState, action) {
      const { index } = action.payload;
      const measurements = state.measurements.filter((_, i) => i !== index);
      return { ...state, measurements };
    },
    [MeasurementToolActionTypes.CLEAR_ALL_MEASUREMENTS](state: measurementToolState) {
      return { ...state, startingPoint: null, endingPoint: null, measurements: [], enabled: false, visible: false };
    },
    [MeasurementToolActionTypes.RESET_CURRENT_MEASUREMENT](state: measurementToolState) {
      return { ...state, startingPoint: null, endingPoint: null };
    },
  }),
}

